module.exports = __webpack_public_path__ + "img/bigBrandLOGO.d1b31533.png";